<template>
  <p :class="['line_item', {'is-result': isResult}]">
    <span class="line_item--label text-uppercase">{{ label }}</span>
    <span class="line_item--value">{{ valueAmount }}{{ time ? ' x ' + time + ' mo' : '' }}</span>
  </p>
</template>

<script>
export default {
  name: "AnalysisItem",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean],
    },
    time: {
      type: [String, Number],
    },
    isPercentage: {
      type: Boolean,
      default: false
    },
    isBoolean: {
      type: Boolean,
      default: false
    },
    isResult: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    valueAmount() {
      if(!this.value) {
        return '--'
      }

      if(this.isPercentage) {
        return this.value + '%';
      }

      if(this.isBoolean) {
        return this.value ? 'Yes' : 'No';
      }

      if(this.isResult && !this.value) {
        return '$0.00';
      }

      return this.$utils.formatCurrency(this.value);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.line_item {
  margin-top: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid $border;

  &:last-of-type {
    padding-bottom: 0;
    border-bottom: none;
  }

  &--label {
    font-size: 0.75rem;
  }

  &--value {
    float: right;
    font-weight: normal;
  }

  &.is-result {
    border-bottom: none;

    .line_item--label {
      color: $text;
    }

    .line_item--value {
      color: $primary
    }
  }
}
</style>
